import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  // Config
  static targets = ['input', 'output'];

  static values = { min: Number, max: Number };

  static classes = ['inputError', 'outputError'];

  connect() {
    useEventListener(this, this.inputTarget, 'input', this.updateCount);
    this.updateCount();
  }

  updateCount() {
    const input = this.inputTarget;
    const output = this.outputTarget;
    const count = input.value.length;

    if (this.hasMaxValue) {
      output.textContent = `${count} / ${this.maxValue}`;
    } else {
      output.textContent = count;
    }

    if (this.minValue && count < this.minValue) {
      if (this.hasInputErrorClass) this.inputTarget.classList.add(this.inputErrorClass);
      if (this.hasOutputErrorClass) this.outputTarget.classList.add(this.outputErrorClass);
    } else if (this.maxValue && count > this.maxValue) {
      if (this.hasInputErrorClass) this.inputTarget.classList.add(this.inputErrorClass);
      if (this.hasOutputErrorClass) this.outputTarget.classList.add(this.outputErrorClass);
    } else {
      if (this.hasInputErrorClass) this.inputTarget.classList.remove(this.inputErrorClass);
      if (this.hasOutputErrorClass) this.outputTarget.classList.remove(this.outputErrorClass);
    }
  }
}
